import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { setOpen } = useCart();
  return (
    <div className="flex min-h-screen items-center justify-center px-6 pt-20" data-testid="payment-cancel-page">
      <div className="max-w-lg text-center">
        <p className="text-[0.68rem] font-bold uppercase tracking-[0.34em] text-burgundy">Checkout Paused</p>
        <h1 className="mt-4 font-serif text-5xl leading-tight text-navy">
          The runway <em className="text-gold">waits</em> for you.
        </h1>
        <p className="mt-6 leading-relaxed text-navy/60">
          No charge was made. Your selection is still tucked safely in your cart whenever you are ready to step back in.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <button
            onClick={() => {
              navigate("/");
              setOpen(true);
            }}
            data-testid="cancel-return-cart"
            className="bg-navy px-9 py-4 text-[0.7rem] font-bold uppercase tracking-[0.28em] text-cream transition-colors duration-300 hover:bg-burgundy"
          >
            Return to Cart
          </button>
          <button
            onClick={() => navigate("/shop")}
            data-testid="cancel-back-to-shop"
            className="flex items-center gap-2 border border-navy/20 px-9 py-4 text-[0.7rem] font-bold uppercase tracking-[0.28em] text-navy transition-colors duration-300 hover:border-navy"
          >
            <ArrowLeft className="h-4 w-4" strokeWidth={1.8} /> Keep Browsing
          </button>
        </div>
      </div>
    </div>
  );
}
